/* Contextual, on-site enquiries. Shopify handles delivery and server success. */
(() => {
  // Texte in der Sprache der Seite: window.cmT.contact aus snippets/cm-x-js-texts (Texte in snippets/cm-xt-js, Abschnitt contact). Fehlt cmT
  // oder ein Schlüssel, gilt der deutsche Text hier; {name} wird ersetzt.
  const cmTexts = (window.cmT && window.cmT.contact) || {};
  const tx = (key, de, vars) => {
    const own = cmTexts[key];
    const text = typeof own === 'string' && own && !/^(translation missing|\[text fehlt)/i.test(own) ? own : de;
    return vars ? text.replace(/\{(\w+)\}/g, (all, name) => (name in vars ? vars[name] : all)) : text;
  };
  const people = {'t.vasilia':'Todi Vasilia','p.steinert':'Peter Steinert','d.wilms':'Daniel Wilms','e.hoorn':'Eliana Hoorn','r.vasilia':'Richard Vasilia','m.gang':'Marcel Gang','s.gentile':'Sharon Gentile'};
  // 05.10.2026: count a sales enquiry only after Shopify reports server success.
  function setupInquiryMeasurement(panel) {
    const key = 'cm_inquiry_pending_2026';
    const allowed = () => {
      try {
        const cp = window.Shopify?.customerPrivacy;
        return !!(cp?.marketingAllowed() && cp?.analyticsProcessingAllowed());
      } catch (_) { return false; }
    };
    const success = panel.querySelector('[data-inquiry-success]');
    if (success) {
      try {
        if (!allowed()) return;
        const pending = JSON.parse(sessionStorage.getItem(key) || 'null');
        sessionStorage.removeItem(key);
        if (!pending || !/^[A-Za-z0-9_-]{8,120}$/.test(pending.id) || Date.now() - pending.at > 86400000 || pending.at > Date.now()) return;
        const publish = window.Shopify?.analytics?.publish;
        if (typeof publish === 'function') {
          Promise.resolve(publish('compumac_inquiry_confirmed', {
            confirmed: true, event_id: pending.id
          })).catch(() => {});
        }
      } catch (_) { /* Never interfere with the form confirmation. */ }
      return;
    }
    const form = panel.matches('form') ? panel : panel.querySelector('form');
    if (!form) return;
    form.addEventListener('submit', () => {
      try {
        if (!allowed()) return;
        sessionStorage.removeItem(key);
        const topic = panel.querySelector('#CMTopic')?.value || '';
        if (!['Business IT & Leasing', 'Beratung & Kauf', 'Reparatur & Service', 'Schulung'].includes(topic) || !form.checkValidity()) return;
        sessionStorage.setItem(key, JSON.stringify({ id: 'inquiry_' + crypto.randomUUID(), at: Date.now() }));
      } catch (_) { /* Tracking must never block submission. */ }
    });
  }
  const init = () => {
    const panel = document.querySelector('[data-cm-inquiry]');
    if (!panel || panel.dataset.ready) return;
    panel.dataset.ready = 'true';
    setupInquiryMeasurement(panel);
    const result = panel.querySelector('[data-inquiry-errors], [data-inquiry-success]');
    if (result) { result.focus({preventScroll:true}); result.scrollIntoView({block:'center'}); return; }
    const query = new URLSearchParams(location.search);
    const subject = (query.get('anliegen') || '').replace(/[\u0000-\u001f\u007f]/g, '').slice(0,180).trim();
    const person = people[query.get('kontakt')] || '';
    const topic = panel.querySelector('#CMTopic');
    const topicFor = value => {
      if (/widerruf/i.test(value)) return 'Widerruf';
      if (/bewerbung|karriere/i.test(value)) return 'Bewerbung';
      if (/datenschutz|barrierefrei/i.test(value)) return 'Datenschutz & Barrierefreiheit';
      if (/schulung|kurs|macos/i.test(value)) return 'Schulung';
      if (/leasing|mac\s*75|business|unternehmen/i.test(value)) return 'Business IT & Leasing';
      if (/reparatur|service|support|gerät.*defekt/i.test(value)) return 'Reparatur & Service';
      if (/bestellung|rückgabe|rücksendung/i.test(value)) return 'Bestellung & Rückgabe';
      if (/beratung|kauf|ausstattung/i.test(value)) return 'Beratung & Kauf';
      return 'Sonstiges';
    };
    if (subject || person) {
      panel.querySelector('[data-inquiry-context]').hidden = false;
      panel.querySelector('[data-inquiry-subject]').textContent = subject || tx('subject_default', 'Eine Nachricht an unser Team');
      panel.querySelector('[data-inquiry-person]').textContent = person ? tx('person', 'Gewünschter Kontakt: {person}. Wir leiten deine Nachricht intern weiter.', { person }) : '';
      panel.querySelector('[data-inquiry-subject-input]').value = subject;
      panel.querySelector('[data-inquiry-person-input]').value = person;
      if (subject && !topic.value) topic.value = topicFor(subject);
    }
    // Einsendung (Codex-Paket W05, 05.10.2026): Prüfpauschale vor dem Absenden zeigen – Text kommt aus dem Theme (DE/EN).
    const fee = panel.querySelector('[data-inquiry-sendin-fee]');
    if (fee && /einsend|mail-in|send in/i.test(subject)) fee.hidden = false;
    const help = panel.querySelector('[data-inquiry-message-help]');
    const hint = panel.querySelector('[data-inquiry-hint]');
    const update = () => {
      const notes = {
        'Bewerbung':tx('note_job', 'Erzähl uns kurz, was du mitbringst und welche Aufgabe dich interessiert. Einen Link zu deinem Portfolio kannst du in die Nachricht einfügen. Unterlagen stimmen wir anschließend mit dir ab.'),
        'Widerruf':tx('note_withdrawal', 'Teile uns mit, welchen Vertrag du widerrufen möchtest. Eine Bestellnummer hilft bei der Zuordnung, ist aber keine Voraussetzung. Ein Grund ist nicht erforderlich.'),
        'Schulung':tx('note_training', 'Interessierst du dich für einen Kursplatz oder eine Schulung für dein Team? Nenne uns gerne Thema, Personenzahl und mögliche Zeiträume.'),
        'Business IT & Leasing':tx('note_business', 'Welche Geräte oder Unterstützung braucht ihr? Stückzahl und gewünschter Einsatz helfen uns bei der Vorbereitung.'),
        'Reparatur & Service':tx('note_repair', 'Um welches Gerät geht es und was funktioniert nicht? Bitte keine Passwörter oder Gerätecodes eingeben.'),
        'Bestellung & Rückgabe':tx('note_order', 'Nenne uns gerne deine Bestellnummer, damit wir dir schneller helfen können. Bitte keine Zahlungsdaten eingeben.')
      };
      help.textContent = notes[topic.value] || tx('note_default', 'Was möchtest du wissen? Bitte keine Passwörter, Gerätecodes oder Zahlungsdaten eingeben.');
      hint.textContent = /^Terminanfrage:/i.test(subject) ? tx('hint_appointment', 'Du fragst einen Termin an. Ein Zeitpunkt ist erst mit unserer persönlichen Bestätigung vereinbart.') : tx('hint_default', 'Wir lesen deine Nachricht und antworten dir an die angegebene E-Mail-Adresse.');
    };
    topic.addEventListener('change', update);
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
